<template>
  <v-col
      :class="classFlex"
      :cols="cols"
      :md="md"
      :lg="lg">
    <v-icon v-if="icon">
      {{ icon }}
    </v-icon>
    <label
        v-if="!!label"
        :class="classLabel"
        font-weight-bold>
      {{ label + separator }}
    </label>
    <br v-if="!!label">
    <ul class="items-list">
      <li
          v-for="(item, index) in displayValue"
          :key="index"
          :class="classValue">
        {{ item }}
      </li>
    </ul>
  </v-col>
</template>

<style scoped>
  .items-list {
      list-style-type: none;
      margin-left: 0;
      padding-left: 0;
  }
</style>

<script>
  export default {
    props: {
      display: {
        type: Array,
        default: () => {
          return []
        }
      },
      icon: {
        type: String
      },
      label: {
        type: String,
        default: null
      },
      cols: {
        type: [String, Number],
        default: '12'
      },
      md: {
        type: [String, Number],
        default: null
      },
      lg: {
        type: [String, Number],
        default: null
      },
      classFlex: {
        type: String,
        default: 'xs12 pt-4 pb-2'
      },
      classLabel: {
        type: String,
        default: 'v-label v-label--active font-weight-bold textcolor--text'
      },
      classValue: {
        type: String,
        default: 'v-label v-label--active textcolor--text my-2'
      },
      separator: {
        type: String,
        default: ': '
      },
      noData: {
        type: String,
        default: 'Не указано'
      }
    },
    computed: {
      displayValue () {
        return this.display && this.display.length
          ? this.display
          : [this.$t(this.noData)]
      }
    }
  }
</script>
